import React from 'react';
import PropTypes from 'prop-types';

const ColGrid = function (props) {
  return (
    <div className="channel-steering-grid">
      <div className={`${props.left}`} />
      <div className={`${props.middle}`}>{props.children}</div>
      <div className={`${props.right}`} />
    </div>
  );
};

// Property Types
ColGrid.propTypes = {
  children: PropTypes.element.isRequired,
  left: PropTypes.string,
  middle: PropTypes.string,
  right: PropTypes.string,
};

ColGrid.defaultProps = {
  left: 'channel-steering-grid-left',
  middle: 'channel-steering-grid-middle',
  right: 'channel-steering-grid-right',
};

export default ColGrid;
